<template>
  <v-app class="background_general">
    <div v-if="getLogin">
      <v-toolbar color="primary" fixed>
        <v-toolbar-title class="hidden-sm-and-down">
          <img class="logo_trawling_web" @click="redirect()" :src="logo" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn to="/home" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">home</v-icon>
            <span>{{ 'client_dashboard.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn to="/statistics" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">show_chart</v-icon>
            <span>{{ 'statistics.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn to="/workers" icon>
          <v-tooltip bottom>
            <v-icon to="workers" color="white" slot="activator">developer_board</v-icon>
            <span>{{ 'workers.title' | t }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn to="/playground" icon>
          <v-tooltip bottom>
            <v-icon to="playground" color="white" slot="activator">rocket</v-icon>
            <span>{{ 'playground.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <!--
        <v-btn to="/shop" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">shopping_cart</v-icon>
            <span>{{ 'shop.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn to="/billing" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">assignment</v-icon>
            <span>{{ 'billing.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        -->
        <v-btn to="/documentation" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">help</v-icon>
            <span>{{ 'documentation.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn to="/settings" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">person</v-icon>
            <span>{{ 'settings.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn v-if="getAdmin" to="/users" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">people</v-icon>
            <span>{{ 'usermanager.title' | t }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn @click="rmKey()" icon>
          <v-tooltip bottom>
            <v-icon color="white" slot="activator">exit_to_app</v-icon>
            <span>{{ 'exit.title' | t }}</span>
          </v-tooltip>
        </v-btn>
      </v-toolbar>
      <v-content fluid>
        <router-view sm12 md12 />
      </v-content>
    </div>
    <div v-else>
      <v-toolbar color="primary">
        <v-toolbar-title>
          <img class="logo_trawling_web" @click="redirect()" :src="logo" />
        </v-toolbar-title>
      </v-toolbar>
      <router-view name="out"></router-view>
    </div>
    <v-footer class="pa-3 text_footer" fixed color="primary">
      <v-spacer>{{ 'footer.text' | t }}</v-spacer>
      <div color="white">&copy; {{ new Date().getFullYear() }} {{ 'footer.copy' | t }}</div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import logo from '@/assets/logo-trawling-2023-negra.svg'

export default {
  data() {
    return {
      mini: true,
      menu: true,
      options: [
        { title: 'Home', icon: 'home' },
        { title: 'Shop', icon: 'shopping_cart' },
        { title: 'Settings', icon: 'settings' }
      ],
      logo
    }
  },
  created() {
    this.getSession()
    const language = localStorage.getItem('language')
    if (language) this.$i18n.locale = language
  },
  computed: {
    ...mapGetters(['getLogin', 'getAdmin'])
  },
  methods: {
    ...mapActions(['rmKey', 'getSession']),
    redirect() {
      window.location = 'https://trawlingweb.com/'
    }
  }
}
</script>

<style scoped>
.logo_trawling_web {
  width: auto;
  height: 60px;
  margin-top: 10px;
}

.text_footer {
  color: #ffffff !important;
  caret-color: #ffffff !important;
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}

.background_general {
  background-color: #ffffff !important;
}
</style>
